// Derives a "recently active / online" status from a user's last_active_at timestamp.
// Request-driven (REST polling), so this reflects the last activity, not live presence.
export function presenceFrom(lastActiveAt, onlineMinutes = 3) {
  if (!lastActiveAt) return { online: false, label: "Never signed in", tone: "idle" };
  const t = new Date(lastActiveAt).getTime();
  if (Number.isNaN(t)) return { online: false, label: "—", tone: "idle" };
  const mins = Math.floor((Date.now() - t) / 60000);
  if (mins < 0) return { online: true, label: "Online now", tone: "online" };
  if (mins < onlineMinutes) return { online: true, label: "Online now", tone: "online" };
  if (mins < 60) return { online: false, label: `Active ${mins}m ago`, tone: "recent" };
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return { online: false, label: `Active ${hrs}h ago`, tone: "away" };
  const days = Math.floor(hrs / 24);
  if (days === 1) return { online: false, label: "Active yesterday", tone: "away" };
  if (days < 30) return { online: false, label: `Active ${days}d ago`, tone: "away" };
  return { online: false, label: "Inactive", tone: "idle" };
}
